import { render, staticRenderFns } from "./HeaderFavorites.vue?vue&type=template&id=c997560a&scoped=true&"
import script from "./HeaderFavorites.vue?vue&type=script&lang=js&"
export * from "./HeaderFavorites.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFavorites.vue?vue&type=style&index=0&id=c997560a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997560a",
  null
  
)

export default component.exports